(function () {
  'use strict';

  function register() {
    if (!window.Alpine || Alpine.data == null) return;
    if (window.__amcStickyBookWizardRegistered) return;
    window.__amcStickyBookWizardRegistered = true;

    Alpine.data('xStickyBookWizard', function () {
      return {
        show: false,
        dateLabel: '',
        timeLabel: '',
        variantLabel: '',
        hasSelection: false,

        wizardRoot: function () {
          return document.querySelector(
            '[data-popup-city-wizard], [data-amc-shop-wizard], [data-workshop-city-wizard]'
          );
        },

        isPlaceholder: function (t) {
          var s = (t || '').replace(/\s+/g, ' ').trim().toLowerCase();
          if (!s) return true;
          return (
            s === 'time' ||
            s === 'date' ||
            s === 'pick a time' ||
            s === 'pick a date' ||
            s === 'select a time' ||
            s === 'select a date' ||
            s === 'choose a time' ||
            s === 'choose a date'
          );
        },

        onScroll: function () {
          var position = window.innerWidth < 1025 ? 280 : 520;
          var y = document.documentElement.scrollTop || document.body.scrollTop || 0;
          var bookVisible = false;
          var root = this.wizardRoot();
          var foot =
            root &&
            root.querySelector(
              '.wcf-step--on .wcf-step__foot, .wcf-step--on .pcw-foot, .pcw-step--variants.wcf-step--on .pcw-foot'
            );
          if (foot) {
            var fr = foot.getBoundingClientRect();
            bookVisible = fr.top < window.innerHeight - 8 && fr.bottom > 0;
          }
          var next = y > position && !bookVisible;
          if (next === this.show) return;

          this.show = next;
          var html = document.documentElement;
          if (next) {
            if (this._stickyOffTimer) {
              window.clearTimeout(this._stickyOffTimer);
              this._stickyOffTimer = null;
            }
            html.classList.add('amc-sticky-book-on');
            this.refreshSelection();
          } else {
            var self = this;
            this._stickyOffTimer = window.setTimeout(function () {
              self._stickyOffTimer = null;
              if (!self.show) html.classList.remove('amc-sticky-book-on');
            }, 320);
          }
        },

        refreshSelection: function () {
          var root = this.wizardRoot();
          this.dateLabel = '';
          this.timeLabel = '';
          this.variantLabel = '';
          this.hasSelection = false;
          if (!root) return;

          var self = this;
          var dateEl = root.querySelector('[data-pcw-date-label]');
          var timeEl = root.querySelector('[data-pcw-time-label]');
          var dateText = dateEl ? (dateEl.textContent || '').trim() : '';
          var timeText = timeEl ? (timeEl.textContent || '').trim() : '';

          if (dateText && !self.isPlaceholder(dateText)) {
            this.dateLabel = dateText;
          }
          if (!this.dateLabel) {
            var day = root.querySelector(
              '[data-wcf-cal-day].is-selected, [data-wcf-cal-day][aria-pressed="true"]'
            );
            if (day) {
              var key = day.getAttribute('data-wcf-cal-day') || '';
              if (key) {
                var bits = key.split('-');
                if (bits.length === 3) {
                  var months = [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec'
                  ];
                  var mi = parseInt(bits[1], 10) - 1;
                  this.dateLabel =
                    (months[mi] || bits[1]) + ' ' + parseInt(bits[2], 10) + ', ' + bits[0];
                } else {
                  this.dateLabel = key;
                }
              }
            }
          }

          if (timeText && !self.isPlaceholder(timeText)) {
            this.timeLabel = timeText;
          }
          if (!this.timeLabel) {
            var timeBtn = root.querySelector(
              '[data-wcf-cal-time] button.is-selected, .wcf-cal-time__dd-opt.is-selected, [data-wcf-cal-time].is-selected button, [data-pcw-slot].is-selected, [data-wcf-slot].is-selected'
            );
            if (timeBtn) {
              var t = (timeBtn.textContent || '').replace(/\s+/g, ' ').trim();
              if (t && !self.isPlaceholder(t)) this.timeLabel = t;
            }
          }

          var variantNames = [];
          root.querySelectorAll('[data-wcf-variant-qty]').forEach(function (qtyBox) {
            var valEl = qtyBox.querySelector('[data-wcf-qty-val]');
            var n = valEl ? parseInt((valEl.textContent || '0').trim(), 10) : 0;
            if (!n || n < 1) return;
            var row = qtyBox.closest('.wcf-variant-row');
            var titleEl =
              row &&
              row.querySelector('.wcf-variant-card__title, .wcf-variant-row__title, .wcf-variant__title');
            var name = titleEl ? (titleEl.textContent || '').trim() : '';
            if (name) variantNames.push(n > 1 ? name + ' ×' + n : name);
          });
          if (variantNames.length >= 3) {
            this.variantLabel = variantNames.length + ' styles';
          } else if (variantNames.length) {
            this.variantLabel = variantNames.join(', ');
          }
          this.hasSelection = !!(this.dateLabel || this.timeLabel || this.variantLabel);
        },

        scrollToWizard: function () {
          var target = this.wizardRoot();
          if (!target) return;
          var top = target.getBoundingClientRect().top + window.pageYOffset;
          var offset = window.innerWidth < 768 ? 72 : 96;
          window.scrollTo({ top: Math.max(0, top - offset), behavior: 'smooth' });
        },

        init: function () {
          this.onScroll();
          var root = this.wizardRoot();
          if (!root) return;
          var self = this;
          root.addEventListener('click', function () {
            setTimeout(function () {
              self.refreshSelection();
            }, 50);
          });
          if (window.MutationObserver) {
            var t = 0;
            var mo = new MutationObserver(function () {
              if (t) window.clearTimeout(t);
              t = window.setTimeout(function () {
                t = 0;
                self.refreshSelection();
              }, 80);
            });
            mo.observe(root, {
              subtree: true,
              childList: true,
              characterData: true,
              attributes: true
            });
          }
        }
      };
    });
  }

  document.addEventListener('alpine:init', register);
  if (window.Alpine) register();
})();
